export default {
    details: "La page que vous recherchez n'existe pas.",
    goHome: "Aller à l'accueil",
    title: 'Page introuvable.',
};
